export const Types = {
    GET_BREAK_DOWN_TABLE_REASON_GROUP: "GET_BREAK_DOWN_TABLE_REASON_GROUP",
    SET_BREAK_DOWN_TABLE_REASON_GROUP: "SET_BREAK_DOWN_TABLE_REASON_GROUP",

    GET_BREAK_DOWN_TABLE_EFFECT_LIST: "GET_BREAK_DOWN_TABLE_EFFECT_LIST",
    SET_BREAK_DOWN_TABLE_EFFECT_LIST: "SET_BREAK_DOWN_TABLE_EFFECT_LIST",

    GET_BREAK_DOWN_TABLE_TECHLIST: "GET_BREAK_DOWN_TABLE_TECHLIST",
    SET_BREAK_DOWN_TABLE_TECHLIST: "SET_BREAK_DOWN_TABLE_TECHLIST",

    GET_BREAK_DOWN_TABLE_COST_CENTER: "GET_BREAK_DOWN_TABLE_COST_CENTER",
    SET_BREAK_DOWN_TABLE_COST_CENTER: "SET_BREAK_DOWN_TABLE_COST_CENTER",

    GET_BREAK_DOWN_TABLE_POOL_LIST: "GET_BREAK_DOWN_TABLE_POOL_LIST",
    SET_BREAK_DOWN_TABLE_POOL_LIST: "SET_BREAK_DOWN_TABLE_POOL_LIST",

    GET_BREAK_DOWN_TABLE_STATUS_LIST: "GET_BREAK_DOWN_TABLE_STATUS_LIST",
    SET_BREAK_DOWN_TABLE_STATUS_LIST: "SET_BREAK_DOWN_TABLE_STATUS_LIST",

    GET_BREAK_DOWN_TABLE_DATA: "GET_BREAK_DOWN_TABLE_DATA",
    SET_BREAK_DOWN_TABLE_DATA: "SET_BREAK_DOWN_TABLE_DATA",

    GET_BREAK_DOWN_TABLE_AREA_LIST: "GET_BREAK_DOWN_TABLE_AREA_LIST",
    SET_BREAK_DOWN_TABLE_AREA_LIST: "SET_BREAK_DOWN_TABLE_AREA_LIST",

    GET_BREAK_DOWN_TABLE_SUB_EQUIPMENT_LIST: "GET_BREAK_DOWN_TABLE_SUB_EQUIPMENT_LIST",
    SET_BREAK_DOWN_TABLE_SUB_EQUIPMENT_LIST: "SET_BREAK_DOWN_TABLE_SUB_EQUIPMENT_LIST",

    RESET_BREAK_DOWN_TABLE_DATA: "RESET_BREAK_DOWN_TABLE_DATA",
};

export const getBreakDownReasonGroup = () => ({
    type: Types.GET_BREAK_DOWN_TABLE_REASON_GROUP,
});

export const setBreakDownListTable = (payload) => ({
    type: Types.SET_BREAK_DOWN_TABLE_REASON_GROUP,
    payload,
});

export const getBreakDownEffectList = () => ({
    type: Types.GET_BREAK_DOWN_TABLE_EFFECT_LIST,
});

export const setBreakDownEffectList = (payload) => ({
    type: Types.SET_BREAK_DOWN_TABLE_EFFECT_LIST,
    payload,
});

export const getTechList = () => ({
    type: Types.GET_BREAK_DOWN_TABLE_TECHLIST,
});

export const setTechList = (payload) => ({
    type: Types.SET_BREAK_DOWN_TABLE_TECHLIST,
    payload,
});

export const getCostCenter = () => ({
    type: Types.GET_BREAK_DOWN_TABLE_COST_CENTER,
});

export const setCostCenter = (payload) => ({
    type: Types.SET_BREAK_DOWN_TABLE_COST_CENTER,
    payload,
});

export const getPoolList = () => ({
    type: Types.GET_BREAK_DOWN_TABLE_POOL_LIST,
});

export const setPoolList = (payload) => ({
    type: Types.SET_BREAK_DOWN_TABLE_POOL_LIST,
    payload,
});

export const getStatusList = () => ({
    type: Types.GET_BREAK_DOWN_TABLE_STATUS_LIST,
});

export const setStatusList = (payload) => ({
    type: Types.SET_BREAK_DOWN_TABLE_STATUS_LIST,
    payload,
});

export const getBreakDownData = (payload) => ({
    type: Types.GET_BREAK_DOWN_TABLE_DATA,
    payload,
});

export const setBreakDownData = (payload) => ({
    type: Types.SET_BREAK_DOWN_TABLE_DATA,
    payload,
});

export const getBreakDownTableArea = (payload) => ({
    type: Types.GET_BREAK_DOWN_TABLE_AREA_LIST,
    payload,
});

export const setBreakDownTableArea = (payload) => ({
    type: Types.SET_BREAK_DOWN_TABLE_AREA_LIST,
    payload,
});

export const getBreakDownTableSubEquipment = (payload) => ({
    type: Types.GET_BREAK_DOWN_TABLE_SUB_EQUIPMENT_LIST,
    payload,
});

export const setBreakDownTableSubEquipment = (payload) => ({
    type: Types.SET_BREAK_DOWN_TABLE_SUB_EQUIPMENT_LIST,
    payload,
});

export const resetBreakDownListTable = () => ({
    type: Types.RESET_BREAK_DOWN_TABLE_DATA,
});
